import React from 'react';
import {FormattedMessage} from 'react-intl';
import {InvoiceMatch} from '../../types';
import MatchedInvoice from './MatchedInvoice';
import styles from './styles.module.scss';

interface MatchedInvoicesGridProps {
  rows: InvoiceMatch[];
  tableRowID: number;
}

const MatchedInvoicesGrid = ({rows, tableRowID}: MatchedInvoicesGridProps) => {
  const matchedByAmount = rows.filter(row => row.criteria === 'amount');
  const matchedByText = rows.filter(row => row.criteria === 'text');
  const prefix = 'bankStatements-matchedInvoices-popup';

  return (
    <div className={styles.matchedInvoicesGridContainer}>
      <div className={styles.headerView}>
        <div className={styles.headerCell}>
          <FormattedMessage id={`${prefix}-column-invoiceID`} defaultMessage="Invoice ID"/>
        </div>
        <div className={styles.headerCell}>
          <FormattedMessage id={`${prefix}-column-agent`} defaultMessage="Agent"/>
        </div>
        <div className={styles.headerCell}>
          <FormattedMessage id={`${prefix}-column-customer`} defaultMessage="Customer"/>
        </div>
        <div className={styles.headerCell}>
          <FormattedMessage id={`${prefix}-column-date`} defaultMessage="Date"/>
        </div>
        <div className={styles.headerCell}>
          <FormattedMessage id={`${prefix}-column-amount`} defaultMessage="Amount"/>
        </div>
        <div className={styles.headerCell}>
          <FormattedMessage id={`${prefix}-column-status`} defaultMessage="Status"/>
        </div>
        <div className={styles.headerCell}>
          <FormattedMessage id={`${prefix}-column-comment`} defaultMessage="Comment"/>
        </div>
        <div className={styles.headerCell}>
          <FormattedMessage id={`${prefix}-column-createReceipt`} defaultMessage="Create receipt"/>
        </div>
        <div className={styles.headerCell}/>
      </div>
      {matchedByAmount.length > 0 && (
        <>
          <div className={styles.matchHeader}>
            <FormattedMessage id={`${prefix}-header-amount`} defaultMessage="Matched by amount"/>
          </div>
          {matchedByAmount.map(row => {
            return (
              <div className={styles.gridBody}>
                <MatchedInvoice invoice={row} tableRowID={tableRowID}/>
              </div>
            );
          })}
        </>
      )}
      {matchedByText.length > 0 && (
        <>
          <div className={styles.matchHeader}>
            <FormattedMessage id={`${prefix}-header-text`} defaultMessage="Matched by description"/>
          </div>
          {matchedByText.map(row => {
            return (
              <div className={styles.gridBody}>
                <MatchedInvoice invoice={row} tableRowID={tableRowID}/>
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};

export default MatchedInvoicesGrid;